<div class="d-flex position-absolute h-100 w-100 request-access-area">
  <div class="display-large">
    <div class="login-container h-100">
      <a href="#">
        <img src="./assets/img/logo.png" class="logo" />
      </a>
      @if (!emailVerificationSubmitted) {
        <form
          class="d-flex flex-column justify-content-center mt-4"
          [formGroup]="emailVerificationForm"
          (ngSubmit)="onEmailVerificationSubmit()"
        >
          <div>
            <h1 translate>request-access.email-verification</h1>
            <p translate>request-access.email-verification-text</p>
            <div class="mb-3">
              <label for="email" class="form-label" translate>user.email</label>
              <input
                id="email"
                class="form-control"
                type="email"
                formControlName="email"
                placeholder=""
                tabindex="1"
                />
              <div class="form-text" translate>request-access.enter-email</div>
              <div class="invalid-feedback">
                @if (emailVerificationForm.controls.email.errors?.['required']) {
                  <div translate>
                    error.required
                  </div>
                }
                @if (emailVerificationForm.controls.email.errors?.['email']) {
                  <div translate>
                    error.email
                  </div>
                }
              </div>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="acceptTerms" formControlName="acceptTerms" tabindex="2"/>
              <label class="form-check-label" for="acceptTerms" translate>request-access.accept-terms</label>
            </div>

            <app-error [error]="error"></app-error>
            <button
              type="submit"
              class="btn btn-primary w-100 mt-4 mb-2"
              [class.disabled]="!emailVerificationForm.valid"
              [ladda]="isLoading"
              tabindex="3"
              >
              {{ 'request-access.verify-email' | translate }}
            </button>
            <p>
              <span translate>request-access.already-account</span>
              <a href="/" translate>login.login</a>
              <span translate>request-access.continue</span>
            </p>
          </div>
        </form>
      }
      @else if (emailVerificationSubmitted && !isSubmitted) {
        <form
          class="d-flex flex-column justify-content-center mt-4"
          [formGroup]="requestAccessForm"
          (ngSubmit)="onSubmit()"
        >
        <div>
          <h1 translate>request-access.signup</h1>
          <p translate>request-access.create-account</p>
          <div class="mb-3">
            <label for="organization" class="form-label" translate>request-access.company-name</label>
            <input
              id="organization"
              class="form-control"
              type="text"
              formControlName="organization"
              placeholder="Company name"
              tabindex="1"
              />
            <div class="form-text" translate>
              request-access.enter-company-name
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.organization.errors?.['required']) {
                <div translate>
                  error.required
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="firstName" class="form-label" translate>user.given_name</label>
            <input
              id="firstName"
              class="form-control"
              type="text"
              formControlName="firstName"
              placeholder="First name"
              tabindex="3"
              />
            <div class="form-text" translate>
              request-access.enter-firstName
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.firstName.errors?.['required']) {
                <div translate>
                  error.required
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="lastName" class="form-label" translate>user.family_name</label>
            <input
              id="lastName"
              class="form-control"
              type="text"
              formControlName="lastName"
              placeholder="Last name"
              tabindex="4"
              />
            <div class="form-text" translate>
              request-access.enter-lastName
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.lastName.errors?.['required']) {
                <div translate>
                  error.required
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="email" class="form-label" translate>user.email</label>
            <input
              id="email"
              class="form-control"
              type="email"
              formControlName="email"
              placeholder="name@example.com"
              tabindex="5"
              />
            <div class="form-text" translate>request-access.enter-email</div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.email.errors?.['required']) {
                <div translate>
                  error.required
                </div>
              }
              @if (requestAccessForm.controls.email.errors?.['email']) {
                <div translate>
                  error.email
                </div>
              }
            </div>
          </div>
          <div class="mb-3">
            <label for="verificationCode" class="form-label" translate>request-access.verification-code</label>
            <input
              id="verificationCode"
              class="form-control"
              type="text"
              formControlName="verificationCode"
              placeholder="Verification code"
              tabindex="6"
              />
            <div class="form-text" translate>
              request-access.enter-verification-code
            </div>
            <div class="invalid-feedback">
              @if (requestAccessForm.controls.verificationCode.errors?.['required']) {
                <div translate>
                  error.required
                </div>
              }
              @if (requestAccessForm.controls.verificationCode.errors?.['pattern']) {
                <div translate>
                  error.pattern
                </div>
              }
            </div>
          </div>

          <div class="mb-3 form-check">
            <input class="form-check-input" type="checkbox" id="acceptTerms" formControlName="acceptTerms"/>
            <label class="form-check-label" for="acceptTerms" translate>request-access.accept-terms</label>
          </div>

          <app-error [error]="error"></app-error>
          <button
            type="submit"
            class="btn btn-primary w-100 mt-4 mb-2"
            [class.disabled]="!requestAccessForm.valid"
            [ladda]="isLoading"
            tabindex="7"
            >
            {{ 'request-access.create' | translate }}
          </button>
          <p>
            <span translate>request-access.already-account</span>
            <a href="/" translate>login.login</a>
            <span translate>request-access.continue</span>
          </p>
        </div>
      </form>
      } @else if (emailVerificationSubmitted && isSubmitted) {
        <div class="mt-5 text-center mb-5">
          <span class="material-icons text-success icon-xl d-block mb-3">check_circle</span>
          <h1 class="mb-3 fw-bold">
            <span translate>request-access.thanks</span> {{ this.requestAccessForm.controls.firstName.value }}!
          </h1>
          <p class="mb-2" translate>request-access.thanks-subtext</p>
          <p class="mb-3" translate>request-access.thanks-subtext2</p>
          <p class="mb-2 text-muted">
            <span translate>request-access.thanks-subtext3</span>
            <a href="mailto:{{ this.requestAccessForm.controls.email.value }}">
              {{ this.requestAccessForm.controls.email.value }}
            </a>
            ({{ this.requestAccessForm.controls.organization.value }})
          </p>
          <p class="mb-4 text-muted">
            <span translate>request-access.thanks-subtext4</span>
            <a href="mailto:support&#64;nimmsta.com">support&#64;nimmsta.com</a>.
          </p>
          <a class="btn btn-primary" href="https://nimmsta.com" translate>request-access.visit-website</a>
        </div>
      }
      <div class="fw-light d-flex gap-1 bottom-0 justify-content-end" style="right: 0.2rem; color: gray; font-size: 0.6em;">
        <a [href]="'imprint.url' | translate" translate target="_blank">imprint.label</a>
        <span>◦</span>
        <a [href]="'privacy.url' | translate" translate target="_blank">privacy.label</a>
        <span>◦</span>
        <a [href]="'terms.url' | translate" translate target="_blank">terms.label</a>
      </div>
    </div>
  </div>
  <div class="w-50 d-none d-md-block">
    <app-product-placement></app-product-placement>
  </div>
</div>
